import { BaseModel } from '../core/abstractions/base.model';

export class SecuritySummaryModel extends BaseModel {
    name: string;
    number: string;
    registeredShares: number;
    registeredSharesWithVotes: number;
    dispoShares: number;
    shareholdersCount: number;
    shareholdersCountWithVotes: number;
    votes: number;
    nominalValue: number;
    numberOfShares: number;
    traderegisterNumberOfShares: number;
    securityCapital: number;

    constructor(init: SecuritySummaryModel) {
        super();
        Object.assign(this, init);
    }
}
